import { GameStatus } from '@betterpool/api-types/games-service';

import type { PickForEntry } from '~/domains/contest/domains/services/interfaces/picks-for-entry.interface';
import type { PlayerDetail } from '~/domains/games/interfaces/player-detail.interface';
import getFormattedScore from '~/domains/contest/utils/getFormattedScore';

import type { PlayerInfo } from '../../types/player';

import { formatNextGame } from './utils';

const parseNonScheduledTeamSport = (
  pickWithLiveData: PickForEntry | PlayerDetail,
  isPlayerTeamAtHome = false
): Partial<PlayerInfo> => {
  const isLive = pickWithLiveData.attributes.gameStatus === GameStatus.IN_PROGRESS;
  const liveDataAttributes = pickWithLiveData.attributes;
  const playerTeamAlias = liveDataAttributes.team?.alias;
  const playerTeamScore = liveDataAttributes.team?.points;
  const opposingTeamAlias = liveDataAttributes.opposingTeam?.alias;
  const opposingTeamScore = liveDataAttributes.opposingTeam?.points;

  return {
    isLive,
    play: (() => {
      if (isPlayerTeamAtHome) {
        return (
          <>
            <strong>
              {playerTeamAlias} {playerTeamScore}
            </strong>
            &nbsp;@ {opposingTeamAlias} {opposingTeamScore}
          </>
        );
      }

      if (pickWithLiveData.attributes.playingAtHome) {
        return (
          <>
            {opposingTeamAlias} {opposingTeamScore} @{' '}
            <strong>
              {playerTeamAlias} {playerTeamScore}
            </strong>
          </>
        );
      }
      return (
        <>
          <strong>
            {opposingTeamAlias} {opposingTeamScore}
          </strong>
          &nbsp;@ {playerTeamAlias} {playerTeamScore}
        </>
      );
    })(),
    nextPlay: formatNextGame(
      new Date(liveDataAttributes.gameStartDateTime ?? liveDataAttributes.gameStartDate)
    ),
    ...(typeof pickWithLiveData?.score === 'number' && {
      points: {
        value: getFormattedScore(pickWithLiveData.score, {
          isWithPrefix: false,
          withoutScoreMark: '0',
        }),
        label: 'FTPS',
      },
    }),
  };
};

export default parseNonScheduledTeamSport;
